import React, {ReactNode, useEffect, useRef, useState, MouseEvent} from "react";

type CalloutProps = {
    children: ReactNode,
    show: boolean,
    onDismiss: () => void
};

export default function Callout(props: CalloutProps) {
    const [rootHeight, setRootHeight] = useState(0);
    const [rootWidth, setRootWidth] = useState(0);
    const [windowWidth] = React.useState(window.innerWidth);
    const [windowHeight] = React.useState(window.innerHeight);
    const rootRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (rootRef && rootRef.current) {
            setRootHeight(rootRef.current.clientHeight);
            setRootWidth(rootRef.current.clientWidth);
            rootRef.current.addEventListener("resize", onResizeRoot);
        }
    });

    useEffect(() => {
        const handleScroll = () => {
            handleDismiss();
        };

        if (props.show) {
            window.addEventListener("scroll", handleScroll);
        } else {
            window.removeEventListener("scroll", handleScroll);
        }


        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [props.show]);

    const onResizeRoot = () => {
        if (rootRef && rootRef.current) {
            setRootHeight(rootRef.current.clientHeight);
            setRootWidth(rootRef.current.clientWidth);
        }
    };

    const handleDismiss = () => {
        props.onDismiss();
    };

    const preventDefault = (e: MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const getTopPosition = () => {
        const heightUsed = windowHeight - rootHeight;
        return heightUsed / 2;
    };

    const getLeftPosition = () => {
      const widthUsed = windowWidth - rootWidth;
      return widthUsed / 2;
    };

    if (!props.show) {
        return null;
    }

    return (
        <div className="callout" onClick={handleDismiss} style={{visibility: props.show ? "visible": "hidden", opacity: props.show ? 1 : 0}}>
            <div className="callout-content">
                <div className="callout-root" ref={rootRef} style={{top: getTopPosition(), left: getLeftPosition()}} onClick={preventDefault}>
                    {props.children}
                </div>
            </div>
        </div>
    );
}